import React from 'react';
import { Error } from './Error';

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.PureComponent<
  Record<string, unknown>,
  ErrorBoundaryState
> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.log(error, errorInfo);
  }

  resetError = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <Error resetError={this.resetError} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
